var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rating"},[_c('img',{attrs:{"src":require("@/assets/icons/star.svg")}}),_c('p',[_vm._v(" "+_vm._s(_vm.star ? _vm.star : '0'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }